import DistributorMixin from './DistributorMixin'

export default {
    mixins: [
        DistributorMixin
    ]
}